import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { confirmTransferApi } from './confirmTransfer.api'
import confirmTransferInitialState from './confirmTransfer.initialState'
import { ConfirmTransferErrorResponse, ConfirmTransferRequestPayload } from './confirmTransfer.types'

export const confirmTransfer = createAsyncThunk(
  urls.logisticsPartner.confirmTransfer,
  async (payload: ConfirmTransferRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload || {}

    try {
      const response = await confirmTransferApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const confirmTransferSlice = createSlice({
  name: urls.logisticsPartner.confirmTransfer,
  initialState: confirmTransferInitialState,
  reducers: {
    resetConfirmTransfer: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmTransfer.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(confirmTransfer.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(confirmTransfer.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ConfirmTransferErrorResponse
        state.success = null
      })
  }
})

export const { actions: confirmTransferActions, reducer: confirmTransferReducer } = confirmTransferSlice
export const { resetConfirmTransfer } = confirmTransferActions
export default confirmTransferSlice.reducer
